module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki04_pc-a67be85e8da0b5a20aa0de7006f5706d.jpg";